import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as reducers from 'Store/reducers';
import { deleteSessionStorage } from '../utilities';

import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';
import TeacherLoginForm from 'Containers/TeacherLoginForm';
import Loading from 'Components/Loading';
import { withRouter, Redirect } from 'react-router';
import { ROUTES } from 'Settings/route-strings';

class PaymentLogin extends React.PureComponent {
  constructor(props) {
    super(props);

    const { multipageFormValues } = props;
    this.state = {};
    // console.log(multipageFormValues);
    if (multipageFormValues && multipageFormValues.username)
      this.state.username = multipageFormValues.username;
  }

  componentDidMount() {
    this.handleRedirect();
  }

  componentDidUpdate() {
    this.handleRedirect();
  }

  handleRedirect = () => {
    // Check to see if we have an active user and send them on their way.
    const { activeUser, history } = this.props;
    if (activeUser) {
      deleteSessionStorage('loggedOutPayment');
      if (activeUser.isAdmin) {
        history.push(ROUTES.SETTINGS_SUBSCRIPTION_PAYMENT);
      } else {
        history.push(ROUTES.EXPLORE);
      }
    }
  };

  render() {
    const { isFetchingActiveUser, authToken, form } = this.props;
    if (form && form.message && form.message.errorCode) {
      return <Redirect to={ROUTES.ERROR_EXPIRED_TRIAL} />;
    }

    if (isFetchingActiveUser && authToken) {
      return <Loading />;
    }

    const loginFormProps = {
      messagePosition: 'content-frame',
    };
    if (this.state && this.state.username)
      loginFormProps.initialFieldSettings = {
        username: {
          value: this.state.username,
        },
      };

    return (
      <main className="Page__content">
        <ContentFrame pageType="transactional" size="small" hasRelativePositing>
          <SectionHeader
            title="Sign in"
            description="It looks like you already have an account! Enter your password to continue."
          />
          <TeacherLoginForm {...loginFormProps} />
        </ContentFrame>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    authToken: reducers.getAuthToken(state),
    activeUser: reducers.getActiveUser(state),
    isFetchingActiveUser: reducers.getIsFetchingActiveUser(state),
    form: reducers.getForm(state, 'teacherLogin'),
    multipageFormValues: reducers.getMultipageFormValues(
      state,
      'loggedOutPayment'
    ),
  };
};

PaymentLogin.propTypes = {
  authToken: PropTypes.string,
  activeUser: PropTypes.object,
  multipageFormValues: PropTypes.object,
  form: PropTypes.object,
  isFetchingActiveUser: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default withRouter(connect(mapStateToProps)(PaymentLogin));
